import { ThunkAction } from "redux-thunk";
import { RootState } from "../reducer";
export const REQUEST_STARTED = "REQUEST_STARTED";
export const REQUEST_COMPLETED = "REQUEST_COMPLETED";
